import { mapBlocks } from "@/mocks/chigua";

export default function MapSection() {
  return (
    <section id="map" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
            <i className="ri-road-map-line" aria-hidden="true"></i>
            吃瓜入口地图
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">活跃板块 · 一目了然</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            吃瓜入口地图把所有活跃瓜田分门别类标注清楚，点进任意板块即可直达对应的热门入口，再也不用四处乱逛找瓜。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {mapBlocks.map((b) => (
            <a key={b.key} href="#events" className="group relative overflow-hidden rounded-xl border border-background-200/70 bg-background-100/60 p-5 transition-all hover:-translate-y-1 hover:border-primary-200 hover:bg-background-100">
              <span className={`absolute right-3 top-3 inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-xs ${b.trend === "热" ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"}`}>
                {b.trend}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${b.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{b.name}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{b.desc}</p>
              <div className="mt-3 flex flex-wrap items-center gap-1.5">
                {b.tags.map((t) => (
                  <span key={t} className="whitespace-nowrap rounded-full bg-background-50 px-2 py-0.5 text-[11px] text-foreground-500 ring-1 ring-background-200">
                    {t}
                  </span>
                ))}
              </div>
              <span className="mt-3 flex items-center gap-1 whitespace-nowrap text-xs text-primary-600">
                <i className="ri-link" aria-hidden="true"></i>
                {b.entries} 个收录入口
                <i className="ri-arrow-right-line ml-auto transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}